export default function getAdjustedDate({ date }) {
	// console.log("getAdjustedDate called with date: ", date)
	if (!date) return null

	if (typeof date === 'string') {
		// Handle "yyyy-mm-dd" string format
		// Split the string and parse as local date to avoid timezone issues
		const parts = date.split('-');
		if (parts.length === 3) {
			const year = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10); // Month is 1-indexed from input
			const day = parseInt(parts[2], 10);

			// Check for valid numbers
			if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
				// Create Date object using year, monthIndex (0-indexed), day
				date = new Date(year, month - 1, day);
			}
		}
	} else if (typeof date === 'number') {
		// Handle Unix timestamp (milliseconds)
		// new Date() directly accepts milliseconds
		date = new Date(date);
	}
	return date



	// date = new Date(date)

	// // const timezoneOffset = date.getTimezoneOffset()
	// const timezoneOffset = 0 // giles asked ahmed
	// console.log("Date = ",date)
	// const adjustedDate = new Date(date.getTime() + timezoneOffset * 60 * 1000)
	// console.log("Adjusted Date = ",adjustedDate)
	// // adjustedDate.setHours(0, 0, 0, 0)

	// return adjustedDate
}
